import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
    return createTanStackRouter({
        routeTree,
        scrollRestoration: false,
        defaultPreload: "intent"
    });
}

declare module "@tanstack/react-router" {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }

    interface StaticDataRouteOption {
        scroll?: "vertical" | "horizontal";
    }
}
